import palette from "../../../styles/palette";

export default {
    tab: {
        whiteSpace: "nowrap",
        paddingLeft: 20,
        paddingRight: 20,
        fontWeight: "bold",
    } as React.CSSProperties,
    tabActive: {
        color: palette.active.primary
    } as React.CSSProperties,
    tabPage: {

        display: "none"
    } as React.CSSProperties,
    tabPageActive: {

        marginTop: 10,
        display: "block"
    } as React.CSSProperties,

}